var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"timeline"},_vm._l((_vm.items),function(item){return _c('timelineItem',{key:item.id,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }